import React, { useState } from 'react';
import { Pill, FlaskConical, Activity, PanelRightOpen } from 'lucide-react';
import { formatDateIST } from '@/utils/date';
import { IITH } from '@/pages/landing/iithBrand';
import PatientPastVisitDrawer from './PatientPastVisitDrawer';

/** Care history row — opens doctor-style past-visit drawer for full Rx. */
export default function CareVisitCard({ visit }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const v = visit || {};
  const rxCount = v.prescriptions?.length || 0;
  const title = `${v.date ? formatDateIST(v.date) : 'Visit'} · Dr. ${v.doctor_name || '—'}`;

  return (
    <>
      <li className="rounded-2xl border border-[#D5DEE8] bg-white shadow-sm overflow-hidden" data-testid={`care-visit-${v.id}`}>
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          className="w-full text-left px-4 py-3.5 flex flex-wrap items-start justify-between gap-2 hover:bg-[#F8FAFC]"
        >
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#071B34]">
              {v.date ? formatDateIST(v.date) : '—'} · {v.doctor_name}
            </p>
            {v.chief_complaint ? (
              <p className="text-[12px] text-[#5A6B7C] mt-1 line-clamp-1">{v.chief_complaint}</p>
            ) : null}
            {v.diagnosis ? (
              <p className="text-[12px] font-medium text-[#071B34] mt-0.5 line-clamp-1">Dx: {v.diagnosis}</p>
            ) : null}
            <div className="mt-1.5 flex flex-wrap gap-2 text-[10px] text-[#7A8B9C]">
              {rxCount ? (
                <span className="inline-flex items-center gap-0.5"><Pill className="h-3 w-3" />{rxCount} medicine{rxCount > 1 ? 's' : ''}</span>
              ) : null}
              {v.investigations?.length ? (
                <span className="inline-flex items-center gap-0.5"><FlaskConical className="h-3 w-3" />{v.investigations.length} test{v.investigations.length > 1 ? 's' : ''}</span>
              ) : null}
              {v.vitals && Object.values(v.vitals).some((x) => x != null && x !== '') ? (
                <span className="inline-flex items-center gap-0.5"><Activity className="h-3 w-3" />Vitals</span>
              ) : null}
            </div>
          </div>
          <span className="inline-flex items-center gap-1 text-[11px] font-semibold shrink-0" style={{ color: IITH.saffron }}>
            View full record
            <PanelRightOpen className="h-4 w-4" />
          </span>
        </button>
      </li>
      {drawerOpen ? (
        <PatientPastVisitDrawer
          consultationId={v.id}
          title={title}
          onClose={() => setDrawerOpen(false)}
        />
      ) : null}
    </>
  );
}
